<app-modal (keydown.enter)="submitIfSelected($event)">

  <h2 class="mb-0100">Merge with...</h2>
  <p>Choose a {{entity?.entityType?.nameSingular}} to merge with &#8220;{{entity | fullName}}&#8221;:</p>
  <div>
    <app-entity-autocomplete *ngIf="!selectedEntity"
                             [labelText]="'Search for a ' + entity?.entityType?.nameSingular"
                             [excludeEntitiesFn]="excludeEntitiesFn(data.entityId)"
                             [entityTypeIds]="[data.entityTypeId]"
                             [campaignId]="data.campaignId"
                             (entitySelected)="entitySelected($event)">
    </app-entity-autocomplete>
    <div class="ab-list-group mb-0075"
         appAutofocus
         tabindex="0"
         *ngIf="selectedEntity">
      <div class="ab-list-item flexJustify-between flexAlign-center pt-0050 pb-0050">
        <div class="d-flex flexWrap-nowrap flexAlign-center flexJustify-start">
          <app-entity-avatar [assessmentLevel]="selectedEntity.currentAssessmentLevel"
                             [spotlightIcon]="selectedEntity.spotlightIcon"
                             [entityTypeId]="selectedEntity.entityTypeId"
                             size="sm">
          </app-entity-avatar>
          <span class="results__name ml-0075">
            <app-entity-name [entity]="selectedEntity"></app-entity-name>
          </span>
        </div>
        <button type="button"
                class="link color--red"
                (click)="selectedEntity = null">
          <i class="fal fa-trash-alt"></i>
        </button>
      </div>
    </div>

    <div class="row dual-btn-row mt-0100">
      <div class="col__ col__lg--50 flexOrder-2--lg">
        <button type="submit"
                class="btn ml-auto"
                (click)="onBeginMergeClicked()"
                [disabled]="!selectedEntity">
          Begin Merge
          <i class="fal fa-arrow-right ml-0050"></i>
        </button>
      </div>
      <div class="col__ col__lg--50">
        <button type="button"
                class="btn btn--whiteRed float-l--lg simple"
                (click)="close()">
          Cancel
        </button>
      </div>
    </div>
  </div>

</app-modal>
